import imageOne from '@/assets/images/cities/london1.jpg'
import imageTwo from '@/assets/images/cities/london2.jpg'
import imageThree from '@/assets/images/cities/london3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'London',
  writeup: '',
  website: 'MyLondonNotaryPublic.com',
  url: 'https://www.mylondonnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(226) 213-4360',
      hours: {
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '10:00AM to 7:00PM',
        saturday: '10:00AM to 7:00PM',
        sunday: '10:00AM to 7:00PM'
      },
      address: 'Kipps Lane Location',
      notes: ''
    },
    {
      name: '',
      open: true,
      phone: '(226) 213-4360',
      hours: {
        monday: '1:00PM to 4:00PM',
        tuesday: '',
        wednesday: '1:00PM to 5:00PM',
        thursday: '1:00PM to 5:00PM',
        friday: '',
        saturday: '',
        sunday: ''
      },
      address: 'Colborne Street Location',
      notes: ''
    },
    {
      name: 'London Mobile Service',
      open: true,
      phone: '(226) 213-4360',
      hours: {
        monday: '6:00PM to 9:00PM',
        tuesday: '6:00PM to 9:00PM',
        wednesday: '6:00PM to 9:00PM',
        thursday: '6:00PM to 9:00PM',
        friday: '6:00PM to 9:00PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: 'Available anywhere in London, Ontario.',
      notes:
        'Our notary comes to you to provide convenient, expedient, and comprehensive service.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontario/cities/london.js